/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { useEffect } from 'react';

/**
 * Custom React hook to reset pagination to page 1 when filter criteria change.
 * Used in data table components to ensure filtered results start from the first page.
 * @param filterModel - Current filter model string used to detect filter changes
 * @param page - Current page number
 * @param setPage - Function to update the page number
 */
export const useResetPageOnFilter = (
  filterModel: string,
  page: number,
  setPage: (page: number) => void
) => {
  useEffect(() => {
    if (page !== 1) {
      setPage(1);
    }
  }, [filterModel]);
};
